<div class="notification__image-wrapper">
  <pp-icon class="notification__image" [ppSrc]="EIconPath.NOTIFICATION_ICON_VIDEO" ppColor="primary-950"></pp-icon>
</div>

@if (
  (ppNotification.changeBody.newValue &&
  ppNotification.changeBody.newValue.length > ppNotification.changeBody.oldValue.length) ||
  !ppNotification.changeBody.oldValue
  ) {
  @if (
    (!ppNotification.changeBody.oldValue && ppNotification.changeBody.newValue.length === 1) ||
    ppNotification.changeBody.newValue.length - ppNotification.changeBody.oldValue.length === 1
    ) {
    <span class="notification__blue-text">{{ 'added' | ppTranslate }}</span>
    {{ 'a' | ppTranslate }}
    <span class="notification__bold">{{ 'video' | ppTranslate | lowercase }}</span>
    {{ 'to_a_point_you' | ppTranslate }}
    {{ notificationReason }}.
  }
  @if (
    (!ppNotification.changeBody.oldValue && ppNotification.changeBody.newValue.length > 1) ||
    ppNotification.changeBody.newValue.length - ppNotification.changeBody.oldValue.length > 1
    ) {
    <span class="notification__blue-text">{{ 'added' | ppTranslate }}</span>
    {{
    ppNotification.changeBody.oldValue
    ? ppNotification.changeBody.newValue.length - ppNotification.changeBody.oldValue.length
    : ppNotification.changeBody.newValue.length
    }}
    <span class="notification__bold">{{ 'videos' | ppTranslate | lowercase }}</span>
    {{ 'to_a_point_you' | ppTranslate }}
    {{ notificationReason }}.
  }
}

@if (
  (ppNotification.changeBody.oldValue &&
  ppNotification.changeBody.oldValue.length > ppNotification.changeBody.newValue.length) ||
  !ppNotification.changeBody.newValue
  ) {
  @if (
    (!ppNotification.changeBody.newValue && ppNotification.changeBody.oldValue.length === 1) ||
    ppNotification.changeBody.oldValue.length - ppNotification.changeBody.newValue.length === 1
    ) {
    <span class="notification__blue-text"> {{ 'removed' | ppTranslate }}</span>
    {{ 'a' | ppTranslate }}
    <span class="notification__bold"> {{ 'video' | ppTranslate | lowercase }}</span>
    {{ 'from_a_point_you' | ppTranslate }}
    {{ notificationReason }}.
  }
  @if (
    (!ppNotification.changeBody.newValue && ppNotification.changeBody.oldValue.length > 1) ||
    ppNotification.changeBody.oldValue.length - ppNotification.changeBody.newValue.length > 1
    ) {
    <span span class="notification__blue-text"> {{ 'removed' | ppTranslate }}</span>
    {{
    ppNotification.changeBody.oldValue
    ? ppNotification.changeBody.newValue.length - ppNotification.changeBody.oldValue.length
    : ppNotification.changeBody.newValue.length
    }}
    <span class="notification__bold"> {{ 'videos' | ppTranslate | lowercase }}</span>
    {{ 'from_a_point_you' | ppTranslate }}
    {{ notificationReason }}.
  }
}
